import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { injectIntl, FormattedMessage } from 'react-intl'
import { ref, child, query, orderByChild, equalTo, limitToLast, onValue, off } from 'firebase/database'
import { getFirebaseDatabase } from '../../../Core/Firebase/firebase.config'
import { Firebase } from '../../../Core'
import * as activitySelectors from '../../Activity/activity.selectors'
import PropTypes from 'prop-types'
import Post from './Post'
import * as utils from '../ranking.utils'

import { Game } from '../../../Core'

import * as actions from '../ranking.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as tutorialSelectors from '../../../Tutorial/tutorial.selectors'
/**
 *  Main ranking vieew
 */
class Feed extends React.Component {
  /****/
  constructor(props) {
    super(props)
    this.state = {
      showFeed: false,
      feed: {},
      numberOfFeeds: 15,
    }

    // Bind methods
    this.setFeedListener = this.setFeedListener.bind(this)
  }

  // Optimize re-renders
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState) {
      return true
    }

    const criticalProps = [
      'firebasePath', 'visitUser', 'user', 'visitorInfo', 
      'isTutorial', 'filter', 'totalFeed'
    ]

    for (const prop of criticalProps) {
      if (this.props[prop] !== nextProps[prop]) {
        return true
      }
    }

    return false
  }

  componentDidMount() {
    const { firebasePath, isTutorial } = this.props

    if (isTutorial) return
    const database = getFirebaseDatabase()
    if (database) {
      this.listener = child(ref(database), `${firebasePath}/feed`)
    }
    this.setFeedListener()
  }

  setFeedListener() {
    const { visitUser, user } = this.props
    const { numberOfFeeds } = this.state
    
    if (!this.listener) return
    
    if (visitUser) {
      // Search for the feeds of the user that is being visited
      const feedQuery = query(
        this.listener,
        orderByChild('data/colonyName'),
        equalTo(user.colonyName),
        limitToLast(numberOfFeeds)
      )
      this.unsubscribe = onValue(feedQuery, (snapshot) => {
        this.setState({ feed: snapshot.val() || {} })
      })
    } else {
      // Search for all feeds
      const feedQuery = query(
        this.listener,
        orderByChild('position'),
        limitToLast(numberOfFeeds)
      )
      this.unsubscribe = onValue(feedQuery, (snapshot) => {
        this.setState({ feed: snapshot.val() || {} })
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.numberOfFeeds != prevState.numberOfFeeds) {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      this.setFeedListener()
    }
  }

  componentWillUnmount() {
    const { isTutorial } = this.props
    if (isTutorial) return
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
  getBattleInfo() {
    const { otherUserBattleActivity } = this.props
    let ok = false
    if (Array.isArray(otherUserBattleActivity) && otherUserBattleActivity.length) {
      // array exists and is not empty
      ok = true
    }
    let battleInfo = ok ? otherUserBattleActivity : false

    return battleInfo
  }
  renderStateOfTime(session, turn) {
    return (
      <span>
        <FormattedMessage
          id={'feed.time'}
          style={{ padding: '2px' }}
          values={{ session: session, turn: turn }}
        />
      </span>
    )
  }
  renderBattles(battleInfo, index) {
    const { user, players } = this.props
    const { data: feedData, type, session, turn } = battleInfo[0]
    let winner = utils.getNameFromLicense(players, feedData.winnerId).colonyName
    let loser = utils.getNameFromLicense(players, feedData.loserId).colonyName

    switch (type) {
      case 'BATTLE_WON':
        return (
          <div key={`sessionWinner_${index}`} className={`mis--feed__item 'important'`}>
            {this.renderStateOfTime(session, turn)}
            <br></br>
            <span className="icon-desafio"></span>
            <FormattedMessage
              id={'feed.winBattle'}
              values={{ loser: loser, winner: user.colonyName }}
            />
          </div>
        )
      case 'BATTLE_LOST':
        return (
          <div key={`sessionLooser_${index}`} className={`mis--feed__item 'important'`}>
            {this.renderStateOfTime(session, turn)}
            <br></br>
            <span className="icon-desafio"></span>
            <FormattedMessage
              id={'feed.lostBattle'}
              values={{ loser: user.colonyName, winner: winner }}
            />
          </div>
        )
      default:
        return null
    }
  }

  renderPost(feed, index, itemId) {
    const { user, players, addPopup, setChatTarget, addHowlSound } = this.props
    return (
      <Post
        key={index}
        feed={feed}
        index={index}
        itemId={itemId}
        user={user}
        players={players}
        addPopup={addPopup}
        setChatTarget={setChatTarget}
        addHowlSound={addHowlSound}
      />
    )
  }

  render() {
    const { showFeed, feed } = this.state
    const { visitUser, isTutorial } = this.props
    let battleInfo = !isTutorial ? this.getBattleInfo() : {}

    // The keys in the feed are prefixed with 'news_' so we remove the first 5 chars before sorting it
    const keys = Object.keys(feed).sort(
      (key1, key2) => parseInt(key1.slice(5)) - parseInt(key2.slice(5))
    )
    return (
      <div className={`mis--feed ${showFeed ? 'active' : ''}`}>
        <div className="mis--feed__container">
          <div className="mis--feed__layer">
            {keys.reverse().map((itemId, index) => this.renderPost(feed, index, itemId))}
            {battleInfo && visitUser
              ? Object.keys(battleInfo)
                  .reverse()
                  .map((itemId, index) => this.renderBattles(battleInfo, index))
              : null}
          </div>
          <span
            className="mis--more__feeds"
            onClick={() =>
              this.setState((prevState) => {
                return { numberOfFeeds: prevState.numberOfFeeds + 15 }
              })
            }
          >
            <span>More feeds</span>
          </span>
        </div>
        <div onClick={() => this.setState({ showFeed: !showFeed })} className="mis--feed__button">
          <span className={`icon-angle-${showFeed ? 'left' : 'right'}`}></span>
          <span className="vertical--text">
            <FormattedMessage id="feed.title" />
          </span>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  otherUserBattleActivity: activitySelectors.getOthersBattlesActivity(state),
  players: Firebase.selectors.getPlayersRanking(state),
  isTutorial: tutorialSelectors.isTutorialMode(state),
})

const mapDispatchToProps = (dispatch) => ({
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  setChatTarget: bindActionCreators(actions.setChatTarget, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

Feed.propTypes = {
  firebasePath: PropTypes.string,
  user: PropTypes.object,
  visitUser: PropTypes.bool,
  otherUserBattleActivity: PropTypes.array,
  players: PropTypes.array,
  isTutorial: PropTypes.bool,
  addPopup: PropTypes.func,
  setChatTarget: PropTypes.func,
  addHowlSound: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Feed))
